export const VARIANTS = {
  DEFAULT: 'default',
  SMALL: 'small',
};
export const CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: '60px',
  [VARIANTS.SMALL]: '48px',
};
export const CARD_NAME_MAX_HEIGHT_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: '40px',
  [VARIANTS.SMALL]: '32px',
};
export const CARD_LIST_MAX_SIZE_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: 9,
  [VARIANTS.SMALL]: 4,
};
